import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppComponent } from "app/app.component";
import { appModuleImports } from "app/app.module.imports";
import { appModuleProviders } from "app/app.module.providers";
import { MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions } from "@angular/material/core";

const rippleOpts: RippleGlobalOptions = {
  animation: { enterDuration: 120, exitDuration: 80 },
  terminateOnPointerUp: true
};

@NgModule({
  imports: [BrowserModule, BrowserAnimationsModule, ...appModuleImports],
  providers: [...appModuleProviders, { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: rippleOpts }],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
